import { Button, ButtonGroup, cn } from "@pdfking/components"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { ArrayQ, NullQ } from "@pdfking/structs"
import { Items } from "@pdfking/tfunc"

import { SelectMixin } from "../mixins/SelectMixin"

// The selected segment fills with `primary` — in this theme `secondary` sits
// at the same lightness as the idle hover, so it barely read as active. The
// `dark:` copies are needed because the outline variant's own `dark:bg-input`
// is a separate modifier that would otherwise win in dark mode.
const ACTIVE =
  "bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground dark:bg-primary dark:hover:bg-primary/90"

export const DjButton = CreateRenderFunction({
  computed: {
    selected_keys(): string[] {
      if (ArrayQ(this.input)) return (this.input as unknown[]).map(String)
      return NullQ(this.input) ? [] : [String(this.input)]
    },
  },
  methods: {
    toggle(key: string) {
      if (this.multiple) {
        const keys = this.selected_keys
        this.onselect?.(keys.includes(key) ? keys.filter(k => k !== key) : [...keys, key])
      } else {
        this.onselect?.(key)
      }
    },
  },
  mixins: [SelectMixin] as const,
  props: {
    className: "w-full",
    input: undefined as unknown,
    multiple: false,
  },
  render() {
    return (
      <ButtonGroup className={cn("w-full", this.className)} id={this.dom_id}>
        {Items(this.choices).map(([key, label]) => {
          const selected = this.selected_keys.includes(key)
          return (
            <Button
              className={cn("flex-1 font-normal", selected && ACTIVE)}
              disabled={this.disabled}
              key={key}
              onClick={() => this.toggle(key)}
              size="sm"
              type="button"
              variant="outline"
            >
              <span dangerouslySetInnerHTML={{ __html: label }} />
            </Button>
          )
        })}
      </ButtonGroup>
    )
  },
})
